/**
 * Spatial ink — extracted verbatim from the shipped editor/gallery constants.
 *
 * Sources:
 *   • UploadFloor.js → EDITOR_TOP_BAR_ICON_ENABLED  → ink.primary
 *   • UploadFloor.js → EDITOR_TOP_BAR_ICON_DISABLED → ink.disabled
 *   • UploadFloor.js → EDITOR_FOOTER_ICON_TONE      → ink.secondary
 *   • UploadFloor.js → footer label color           → ink.secondary
 *   • UploadFloor.js → FAB icon color "#0D0D0D"     → ink.fabLabel
 *   • ManuallyItems.js → chip muted "rgba(60, 60, 67, 0.6)" → ink.muted
 */
export const ink = {
  primary: "#202124",
  fabLabel: "#0D0D0D",
  secondary: "rgba(60, 60, 67, 0.78)",
  muted: "rgba(60, 60, 67, 0.6)",
  tertiary: "rgba(60, 60, 67, 0.45)",
  disabled: "rgba(60, 60, 67, 0.36)",
};
